// Slider for Mobile only
if ($(window).width() < 750) {
  $('.video_box_slide').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1
  }); 
} 
// Slider for Mobile only


// document.querySelector('.videoSliderWrapper .right-arrow').addEventListener('click', function () {
//   const slider = document.getElementById('prodVideoMainSlide');
//   slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: 'smooth' });
// });

// document.querySelector('.videoSliderWrapper .left-arrow').addEventListener('click', function () {
//   const slider = document.getElementById('prodVideoMainSlide');
//   slider.scrollBy({ left: -slider.clientWidth * 0.8, behavior: 'smooth' });
// });

document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector('.videoSliderWrapper');
  const slider = document.getElementById('prodVideoMainSlide');
  const btnRight = document.querySelector('.videoSliderWrapper .right-arrow');
  const btnLeft = document.querySelector('.videoSliderWrapper .left-arrow');

  // Safety check
  if (!wrapper || !slider || !btnRight || !btnLeft) return;

  // Count video cards
  const cardCount = slider.querySelectorAll('.videoCard').length;

  // If less than 6 cards → hide arrows (or add class)
  if (cardCount < 6) {
    btnRight.style.display = 'none';
    btnLeft.style.display = 'none';

    // OPTIONAL: also add a class
    wrapper.classList.add('no-arrows');
  }

  // Arrow scrolling for desktop
  if (window.innerWidth > 749) {

    btnRight.addEventListener('click', function () {
      slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: 'smooth' });
    });

    btnLeft.addEventListener('click', function () {
      slider.scrollBy({ left: -slider.clientWidth * 0.8, behavior: 'smooth' });
    });

  } else {
    // On smaller screens (<749), hide arrows
    btnRight.style.display = 'none';
    btnLeft.style.display = 'none';
  }

});



// Thumbnair autoplay video
window.addEventListener('DOMContentLoaded', () => {

  // Product meta-video card videos
  const cards = document.querySelectorAll('.videoCard');

  cards.forEach(card => {
    const video = card.querySelector('video');
    const initialBox = card.querySelector('.initialBox');

    const startTime = Number(initialBox.dataset.videostart) || 0;

    video.addEventListener('loadedmetadata', () => {
      const endTime = Math.min(startTime + 3, video.duration);

      if (startTime < video.duration) {
        // First seek
        video.currentTime = startTime;

        // Wait until seek is complete before playing
        video.addEventListener('seeked', () => {
          video.play();

          // Loop control (now reliable)
          video.addEventListener('timeupdate', () => {
            if (video.currentTime >= endTime) {
              video.currentTime = startTime;
              video.addEventListener('seeked', () => {
                video.play();
              }, { once: true });
            }
          });
        }, { once: true });
      }
    });
  });
  // Product meta-video card videos

  // Product meta-video single addvertisement
  const add_card = document.querySelector('.static_loopVideo_one');

  if (add_card) {
    const add_videoWrap = add_card.querySelector('.addContent');
    const add_video = add_videoWrap.querySelector('video');
    const Add_closeBtn = add_card.querySelector('.add_closeBtn');
    const add_startTime = Number(add_videoWrap.dataset.videostart) || 0;

    add_video.addEventListener('loadedmetadata', () => {
      const add_endTime = Math.min(add_startTime + 3, add_video.duration);

      if (add_startTime < add_video.duration) {
        // Jump to start time
        add_video.currentTime = add_startTime;

        add_video.addEventListener('seeked', () => {
          add_video.play();
        }, { once: true });

        // Enforce 3s loop
        add_video.addEventListener('timeupdate', () => {
          if (add_video.currentTime >= add_endTime) {
            add_video.currentTime = add_startTime;
            add_video.play();
          }
        });
      }
    });

    add_videoWrap.addEventListener("click", function () {
      const parentSection = this.closest(".prod_videos_sec_NEW");
      const multiple_videoCards = parentSection.querySelector(".prodVideoMain");
      // const each_videoCard = multiple_videoCards.querySelectorAll(".videoCard");

      if (multiple_videoCards) {
        const firstInitialBox = multiple_videoCards.querySelector(".videoCard .initialBox");
        if (firstInitialBox) {
          firstInitialBox.click(); // simulate click
        }
      }
    });

    Add_closeBtn.addEventListener("click",() => {
      add_video.pause();
      add_card.style.display = "none";
    });
  }
  // Product meta-video single addvertisement

});
// Thumbnair autoplay video

  let scrollTop = 0;
  let currentVideo = null;

  $(document).ready(function () {
    let childrenLength = $('.prodVideoSlider').children().length;

    function initSliderre() {
      $('.prodVideoSlider').slick({
        slidesToShow: 3,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '0px',
        swipe: true,
        draggable: true,
        swipeToSlide: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              centerMode: false,
              slidesToShow: 1
            }
          }
        ]
      });
    }

    if(childrenLength > 3 && $(window).width() > 750){
      initSliderre()
    }
    if(childrenLength > 1 && $(window).width() < 750) {
      initSliderre()
    }

    // function updatePopupHeight() {
    //   const slickTrack = $('.prodVideoSlider .slick-track');
    //   const currentSlide = $('.prodVideoSlider .slick-slide.slick-current');
    //   const slideHeight = currentSlide.outerHeight(true);
    
    //   $('.prodVideo_ContentMain').height(slideHeight);
    // }

    $('.prodVideoSlider').on('click', '.soundControl', function () {
      const video = $(this).siblings('video')[0];
      if ($(this).hasClass('unmute')) {
        $(this).removeClass('unmute');
        video.muted = true;
      } else {
        $(this).addClass('unmute');
        video.muted = false;
      }
    });

    $('.videoCard .initialBox').on('click', function (e) {
      e.preventDefault();
      const index = $(this).closest('.videoCard').data('index');

      if($(".prodVideoSlider").hasClass("has_items_1")) {
        currentVideo = $(".has_items_1 video")[0];
        currentVideo.play()
      } 
      else if($(".prodVideoSlider").hasClass("has_items_2")) {
        let currentItem = $(".slideItem").eq(index);
        currentItem.addClass("actv");
        currentVideo = $(currentItem).find("video")[0];
        currentVideo.play() 
        
        $(".slideItem").click(function(){
          $(this).addClass("actv");
          $(this).siblings().removeClass('actv');
          let prevVideo = $(this).siblings().find("video")[0];
          prevVideo.pause();
          prevVideo.currentTime = 0;

          currentVideo = $(this).find("video")[0];
          currentVideo.play() 
        })
      } 
      else if($(".prodVideoSlider").hasClass("has_items_3")) {
        let currentItem = $(".slideItem").eq(index);
        currentItem.addClass("actv");
        currentVideo = $(currentItem).find("video")[0];
        currentVideo.play();
        currentItem.removeClass("other0");
        currentItem.removeClass("other1");
        $(currentItem).siblings().each(function(ind, val){
          $(this).addClass("other"+ind);
        });
        
        // $(otherItems).each(function(val, index){
        //   console.log(val, index);
        //   // $(this).addClass();
        // });
        
        $(".slideItem").click(function(){
          $(this).addClass("actv");
          $(this).siblings().removeClass('actv');
          $(this).removeClass("other0");
          $(this).removeClass("other1");
          $(this).siblings().removeClass("other0");
          $(this).siblings().removeClass("other1");

          currentVideo = $(this).find("video")[0];
          currentVideo.play();

          let otherItems = $(this).siblings();
          $(otherItems).each(function(ind, val){
            $(this).addClass("other"+ind);
            let prevVideo = $(this).find("video");
            $(prevVideo)[0].pause();
            $(prevVideo)[0].currentTime = 0;
          })
        })
      } 

      scrollTop = $(window).scrollTop();
      $('body').addClass('noScroll').css('top', `-${scrollTop}px`);

      $('.prodVideo_ContentWrap').fadeIn(300).addClass("openModal");
      $('.prodVideoSlider').slick('slickGoTo', index);

      const slide = $('.prodVideoSlider .slick-slide[data-slick-index="' + index + '"]');
      currentVideo = slide.find('video')[0];
      // const currentVideo_height = currentVideo.offsetHeight;
      // const prodMain = $(slide).find('.prodMain'); 
      // if (currentVideo_height > 0) {
      //   let cc = currentVideo_height + 'px';
      //   $(prodMain).css("height", cc);
      // }


       initAllCards();
       
      setTimeout(() => {
        if (currentVideo) currentVideo.play();
        $('.prodVideoSlider').slick('refresh');
      }, 300);
      
    });

    // SUBHRA START
    // $('.prodVideoSlider').on('afterChange', function(event, slick, currentSlide){
    //   const slide = $('.prodVideoSlider .slick-slide[data-slick-index="' + currentSlide + '"]');
    //   const currentVideo = slide.find('video')[0];
    //   const currentVideo_height = currentVideo.offsetHeight;
    //   const prodMain = $(slide).find('.prodMain'); 
    //   if (currentVideo_height > 0) {
    //     let cc = currentVideo_height + 'px';
    //     $(prodMain).css("height", cc);
    //   }
    // });
    // SUBHRA END

      // const slideItems = document.querySelectorAll(".slideItem");
      // slideItems.forEach((slideItem) => {
      //   const currentVideo_height = slideItem.querySelector("video").offsetHeight;
      //   const prodMain = slideItem.querySelector('.prodMain');  
      //   setTimeout(() => {
      //     if (currentVideo_height > 0) {
      //       let cc = currentVideo_height + 'px';
      //       console.log(slideItem, currentVideo_height, prodMain);
      //     }
      //   }, 300);         
      // });     

    // 4. Close popup logic
    function closePopup() {
      $(".slideItem").removeClass("actv");
      $(".slideItem").removeClass("other0");
      $(".slideItem").removeClass("other1");
      $('.prodVideo_ContentWrap').fadeOut(300).removeClass("openModal");

      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }

      $('body').removeClass('noScroll').css('top', '');
      window.scrollTo(0, scrollTop);
    }

    $('.popOverlay, .closeBtn').on('click', function () {
      closePopup();
    });

    // 5. Play/pause video on slide change
    $('.prodVideoSlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
    });

    $('.prodVideoSlider').on('afterChange', function (event, slick, currentSlide) {
      const slide = $('.prodVideoSlider .slick-slide[data-slick-index="' + currentSlide + '"]');
      currentVideo = slide.find('video')[0];
      if (currentVideo) currentVideo.play();
    });

    // Use the theme's native product form so variant, quantity, validation,
    // cart sections and the drawer are handled by the theme itself.
    function addWrap() {
      const mainProduct = document.querySelector(".section-main-product");
      const videoSections = $(".prod_videos_sec_NEW");
      const nativeSelector = ".product-info__buy-buttons-wrapper .product-form__btn-add-to-cart";
      let pendingAdd = false;

      function syncCartCount() {
        const bubble = document.querySelector("#cart-icon-bubble .cart-bubble__container");
        const count = Number(bubble?.dataset.countItem ?? window.xCartHelper?.currentItemCount);
        if (Number.isFinite(count)) {
          videoSections.find("[data-product-video-cart-count]").text(count);
        }
      }

      const drawer = document.getElementById("CartDrawer");
      if (drawer) {
        // Close only once the native flow has rendered and opened the drawer.
        new MutationObserver(() => {
          if (drawer.hasAttribute("open") && pendingAdd) {
            pendingAdd = false;
            closePopup();
            syncCartCount();
            updateButton();
          }
        }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
      }
      document.addEventListener("maximize:cart:updated", syncCartCount);
      const cartBubble = document.getElementById("cart-icon-bubble");
      if (cartBubble) {
        new MutationObserver(syncCartCount).observe(cartBubble, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ["data-count-item"]
        });
      }
      videoSections.on("click.productVideoCart", ".product-video-cart", function () {
        if (!drawer) return;
        pendingAdd = false;
        closePopup();
        drawer.isOpen = true;
      });

      function getNativeButton() {
        return mainProduct?.querySelector(nativeSelector);
      }

      function updateButton() {
        const nativeButton = getNativeButton();
        const loading = nativeButton?.classList.contains("is-loading");
        if (pendingAdd && !loading) {
          const error = mainProduct?.querySelector('[x-ref="error_message"]');
          if (error && error.getClientRects().length && error.textContent.trim()) {
            videoSections.find(".product-video-cart-status").text(error.textContent.trim());
          }
        }
        const unavailable = !nativeButton || nativeButton.disabled ||
          nativeButton.getAttribute("aria-disabled") === "true" ||
          nativeButton.classList.contains("pointer-events-none");
        const label = nativeButton?.querySelector(".btn__text")?.textContent.trim();

        videoSections.find(".cust_aTc_btn").each(function () {
          this.disabled = unavailable;
          this.setAttribute("aria-disabled", String(unavailable));
          this.classList.toggle("sold-out", Boolean(nativeButton?.disabled));
          this.setAttribute("aria-busy", String(Boolean(loading)));
          if (loading) this.textContent = "Adding…";
          else if (label) this.textContent = label;
        });
      }

      // Delegate because Slick may clone/rebuild the popup slides.
      videoSections.off("click.productVideoCart", ".cust_aTc_btn")
        .on("click.productVideoCart", ".cust_aTc_btn", function (event) {
          event.preventDefault();
          event.stopPropagation();
          updateButton();
          const nativeButton = getNativeButton();
          if (this.disabled || !nativeButton) return;

          pendingAdd = true;
          videoSections.find(".product-video-cart-status").text("");
          nativeButton.click();
          updateButton();
        });

      updateButton();
      syncCartCount();
      if (mainProduct) {
        const observer = new MutationObserver(updateButton);
        observer.observe(mainProduct, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled", "class"]
        });
        document.addEventListener("shopify:section:unload", function onUnload(event) {
          if (event.target === mainProduct) {
            observer.disconnect();
            document.removeEventListener("shopify:section:unload", onUnload);
          }
        });
      }
    }

    addWrap();
  });



/*
  function adjustProdMainHeight() {
    if (window.innerWidth >= 750) {
      document.querySelectorAll('.prodVideoSlider .slideItem').forEach(slide => {
        const video = slide.querySelector('video');
        const prodMain = slide.querySelector('.prodMain');

        if (video && prodMain) {
          // Get rendered video height
          const videoHeight = video.offsetHeight;
          console.log("Video height:", videoHeight);

          if (videoHeight > 0) {
            prodMain.style.maxHeight = videoHeight + 'px';
          }
        }
      });
    } else {
      // Reset if below 750px
      document.querySelectorAll('.slideItem .prodMain').forEach(prod => {
        prod.style.maxHeight = '';
      });
    }
  }

  */

  // Run after DOM is ready
  // document.addEventListener('DOMContentLoaded', adjustProdMainHeight);

  // Run also when window resizes
  // window.addEventListener('resize', adjustProdMainHeight);

  // Ensure correct dimensions once video metadata is available
  // document.querySelectorAll('.slideItem video').forEach(video => {
  //   video.addEventListener('loadedmetadata', adjustProdMainHeight);
  // });``



  // This script will check which .slideItem has the .actv class in the .prodVideoSlider.has_items_2 and then apply the corresponding class to the parent.
  document.addEventListener('DOMContentLoaded', (event) => {
    const videoSlider = document.querySelector('.prodVideoSlider.has_items_2');
    const slideItems = videoSlider?.querySelectorAll('.slideItem');

    function updateJustify() {
      // Check if the first slide has the 'actv' class
      if (slideItems[0].classList.contains('actv')) {
        // If it does, set justify-content to flex-end by adding a class
        videoSlider.classList.remove('justify-start');
        videoSlider.classList.add('justify-end');
      } 
      // Check if the second slide has the 'actv' class
      else if (slideItems[1].classList.contains('actv')) {
        // If it does, set justify-content to flex-start
        videoSlider.classList.remove('justify-end');
        videoSlider.classList.add('justify-start');
      }
    }

    // Initial check on page load
    updateJustify();

    // You would also call this function whenever the 'actv' class changes (e.g., in your slider navigation logic)
    // For a basic example, you could add an observer to watch for class changes:
    const observer = new MutationObserver(updateJustify);
    slideItems.forEach(item => {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  });
  // This script will check which .slideItem has the .actv class in the .prodVideoSlider.has_items_2 and then apply the corresponding class to the parent.
